import {
    ACTION_GET_HAPPINESS_TIPS,
    ACTION_POST_CREATE_HAPPINESS_TIPS,
    ACTION_PUT_UPDATE_HAPPINESS_TIPS,
    ACTION_DELETE_HAPPINESS_TIPS,
    SET_HAPPINESS_TIPS
} from "./types/types.js";

import { HappinessTipsService } from "@/services";
import i18n from '@/plugins/i18n';
import Swal from 'sweetalert2';

const actions = {
    [ACTION_GET_HAPPINESS_TIPS]: ({ state, commit }, categoryId = null) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");
                HappinessTipsService.getHappinessTips(idEmpresa, idUsuario, categoryId)
                .then(resp => {
                    console.log('API Response:', resp);
                    if (resp && resp.data && resp.data.payload && resp.data.payload.tips) {
                        commit(SET_HAPPINESS_TIPS, resp.data.payload.tips);
                        resolve(resp);
                    } else if (resp && resp.data && resp.data.data) {
                        commit(SET_HAPPINESS_TIPS, resp.data.data);
                        resolve(resp);
                    } else if (resp && resp.data && Array.isArray(resp.data.payload)) {
                        commit(SET_HAPPINESS_TIPS, resp.data.payload);
                        resolve(resp);
                    } else if (resp && resp.data && Array.isArray(resp.data)) {
                        commit(SET_HAPPINESS_TIPS, resp.data);
                        resolve(resp);
                    } else {
                        reject(new Error('Invalid response structure'));
                    }
                })
                .catch(err => {
                    const errorMessage = err.response && err.response.data && err.response.data.message
                        ? err.response.data.message
                        : err.message || 'Error desconocido';

                    reject(new Error(errorMessage));
                    //reject(err);
                })
                .finally(() => {
                    state.loading = false;
                });
            } catch (error) {
                reject(error);
            }
        });
    },

    [ACTION_POST_CREATE_HAPPINESS_TIPS]: ({ state }, tip) => {
        const formdata = new FormData();
        formdata.append("title", tip.title);
        formdata.append("message", tip.title);
        formdata.append("happinessCategoryTipsId", tip.happinessCategoryTipsId);
        if (tip.miniature) {
            formdata.append("miniature", tip.miniature);
        }
        if (tip.detail) {
            formdata.append("detail", tip.detail);
        }
        if (tip.fileLink) {
            formdata.append("fileLink", tip.fileLink);
        }
        if (tip.active !== undefined) {
            formdata.append("active", tip.active);
        }

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                HappinessTipsService.createHappinessTip(idEmpresa, idUsuario, formdata)
                .then(async (resp) => {
                    if (resp && resp.status === 200) {
                        await Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: i18n.t('happinessTips.actionPostCreateHappinessTips.success'),
                            showConfirmButton: false,
                            timer: 2500
                        });
                        resolve(resp);
                    } else {
                        reject(i18n.t('label.actionReject'));
                    }
                })
                .catch(err => {
                    reject(err);
                })
                .finally(() => state.loading = false);
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_PUT_UPDATE_HAPPINESS_TIPS]: ({ state }, tip) => {
        const formdata = new FormData();
        formdata.append("idTip", tip.idTip);
        formdata.append("title", tip.title);
        formdata.append("message", tip.title);
        formdata.append("happinessCategoryTipsId", tip.happinessCategoryTipsId);
        if (tip.miniature) {
            formdata.append("miniature", tip.miniature);
        }
        if (tip.detail) {
            formdata.append("detail", tip.detail);
        }
        if (tip.fileLink) {
            formdata.append("fileLink", tip.fileLink);
        }
        if (tip.active !== undefined) {
            formdata.append("active", tip.active);
        }

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                HappinessTipsService.updateHappinessTip(idEmpresa, idUsuario, tip.idTip, formdata)
                .then(async (resp) => {
                    if (resp && resp.status === 200) {
                        await Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: i18n.t('happinessTips.actionPutUpdateHappinessTips.success'),
                            showConfirmButton: false,
                            timer: 2500
                        });
                        resolve(resp);
                    } else {
                        reject(i18n.t('label.actionReject'));
                    }
                })
                .catch(err => {
                    reject(err);
                })
                .finally(() => state.loading = false);
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_DELETE_HAPPINESS_TIPS]: ({ state }, formData) => {
        state.loading = true;
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                HappinessTipsService.deleteHappinessTip(idEmpresa, idUsuario, formData)
                .then(async (resp) => {
                    await Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: i18n.t('happinessTips.actionDeleteHappinessTips.success'),
                        showConfirmButton: false,
                        timer: 2500
                    });
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                })
                .finally(() => state.loading = false);
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    }
};

export default actions;
